<!-- 
    Dohvati ID iz urla,
    dohvati sa strapia vijest
 -->

<div class='container singleNews'>
    <div class='row d-flex justify-content-center'>
        <div class="col-sm">
            <img class='img-responsive img-fluid w-100 br-15' src='../../../assets/images/singleNews.png'
                alt='The elite launchpad for everyone'>

        </div>
    </div>

    <div class='row d-flex justify-content-center mt-5'>
        <div class="col-sm-8">
            <h2>{{news[0]['attributes'].title}}</h2>
        </div>
    </div>

    <div class='row justify-content-center my-5'>
        <div class="col-sm-8">
            <div [innerHtml]="body">
               
            </div>
        </div>
    </div>

    <div class="row justify-content-center">
        <div class="col-sm-8">
            <!-- <div *ngIf="news['attributes'].additionalImages">   --> <!-- Refactor - create a field for inserting multiple images that will be spanned
            acrros the site at exact points.-->
            <!-- <img class='img-responsive img-fluid w-100 br-15' src='../../../assets/images/secondImageSingle.png'
                alt='Second image'> -->
            <!-- </div> -->
        </div>
    </div>

    <div class='row d-flex justify-content-center my-5'>
        <div class="col-sm-8">
            <hr class="hr-white">
                <div class="d-flex">
                    <img class='img-responsive img-fluid lbLogo' src='../../../assets/images/Logo.png' alt='logo'>
                    <p class='ml-3 pt-3'>LitBit <br>{{news[0]['attributes'].datePublished.split('-').join(' ')}}</p>
                </div>

                <div class="row pt-1">
                    <div class="col">
                        <a href="https://www.youtube.com/channel/UCPPMLyp8yYBIbdSOTXUvqxw"> <i
                                class="fa-brands fa-youtube fa-md brand"></i></a>
                        <a href="https://www.linkedin.com/company/litbitfinance"><i
                                class="fa-brands fa-linkedin fa-md brand"></i></a>
                        <a href="https://www.reddit.com/r/LitBit_Finance/"><i
                                class="fa-brands fa-reddit fa-md brand"></i></a>
                        <a href="https://www.facebook.com/LitBitFinance/"><i
                                class="fa-brands fa-facebook fa-md brand"></i></a>
                        <a href="https://twitter.com/LitbitFinance"><i class="fa-brands fa-twitter fa-md brand"></i></a>
                        <a href="https://www.instagram.com/litbit_finance/"><i
                                class="fa-brands fa-instagram fa-md brand"></i></a>
                        <a href="https://discord.com/invite/litbit"><i class="fa-brands fa-md fa-discord brand"></i></a>
                        <a href="https://t.me/LitBitfinance"><i class="fa-brands fa-telegram fa-md brand"></i></a>
                        <a href="https://litbit.medium.com/"><i class="fa-brands fa-medium fa-md brand"></i></a>
                        <a href="https://www.tiktok.com/@litbit_finance"><i
                                class="fa-brands fa-tiktok fa-md brand"></i></a>
                    </div>
                </div>
            <hr class="hr-white">
        </div>

    </div>

    <div class='row d-flex justify-content-center'>
        <div class="col-sm-8 mb-5">
            <h3>Featured posts</h3>
        </div>
    </div>

    <div class="row d-flex justify-content-center mb-5 pb-5">
        <div class='col-sm-4'>
            <nb-card>
                <nb-card-body>
                    <img class='img-responsive img-fluid w-100 br-15' src='../../../assets/images/place1.png'
                        alt='picture'>
                    <h3 class='py-3'>{{featuredNews[0]['attributes'].title}}</h3>
                    <p>
                        {{featuredNews[0]['attributes'].description}}
                    </p>
                </nb-card-body>
                <div class='d-flex justify-content-center'>
                    <a href="{{'/news/single/' + featuredNews[0]['id']}}" class='btn btnMiddle' nbButton status='primary'>Read More</a>
                </div>
            </nb-card>
        </div>
        <div class='col-sm-4'>
            <nb-card>
                <nb-card-body>
                    <img class='img-responsive img-fluid w-100 br-15' src='../../../assets/images/place1.png'
                        alt='picture'>
                    <h3 class='py-3'>{{featuredNews[1]['attributes'].title}}</h3>
                    <p>
                        {{featuredNews[1]['attributes'].description}}
                    </p>
                </nb-card-body>
                <div class='d-flex justify-content-center'>
                    <a href="{{'/news/single/' + featuredNews[1]['id']}}" class='btn btnMiddle' nbButton status='primary'>Read More</a>
                </div>
            </nb-card>
        </div>
    </div>
</div>